import {
  Component,
  Inject,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Location, isPlatformBrowser } from '@angular/common';

import { StorageService } from '@services/logic/storage.service';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

import { GenericButtonWithArrow } from '@components/shared/genericButtonWithArrow/genericButtonWithArrow';
import { ExternalService } from '@app/services/http/external.service';

@Component({
  imports: [
    TranslatePipe,
    MatIconModule,
    MatTabsModule,
    GenericButtonWithArrow,
  ],
  selector: 'app-how-it-works-dialog',
  templateUrl: './howItWorksDialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../dialogs.scss', './howItWorksDialog.scss'],
})
export class HowItWorksDialogComponent implements OnInit, OnDestroy {
  public language!: string;
  public activeTabIndex = 0;

  // Static property to track if any dialog is open
  private static isAnyDialogOpen = false;
  private popStateListener?: () => void;

  constructor(
    private storage: StorageService,
    private location: Location,
    public dialogRef: MatDialogRef<HowItWorksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    public externalService: ExternalService,
  ) {
    // Prevent multiple dialogs from being opened
    if (HowItWorksDialogComponent.isAnyDialogOpen) {
      this.dialogRef.close();
      return;
    }

    HowItWorksDialogComponent.isAnyDialogOpen = true;
    this.language = this.storage.languageCookie ?? 'da';
  }

  ngOnInit(): void {
    // Only execute browser-specific code when running in the browser
    if (isPlatformBrowser(this.platformId)) {
      // Handle browser back button
      // Push a state to history so back button closes dialog instead of navigating
      const currentPath = this.location.path();
      history.pushState({ dialogOpen: true }, '', currentPath);

      // Listen for popstate events (back button)
      this.popStateListener = () => {
        this.close();
      };
      window.addEventListener('popstate', this.popStateListener);
    }
  }

  ngOnDestroy(): void {
    // Only execute browser-specific code when running in the browser
    if (isPlatformBrowser(this.platformId)) {
      // Clean up event listener
      if (this.popStateListener) {
        window.removeEventListener('popstate', this.popStateListener);
      }
    }

    // Reset the static flag when dialog is destroyed
    HowItWorksDialogComponent.isAnyDialogOpen = false;
  }

  close(res: any = null): void {
    HowItWorksDialogComponent.isAnyDialogOpen = false;
    this.dialogRef.close(res);
  }

  onCreateTaskClick(): void {
    this.externalService.goToCreateTask();
    this.close();
  }
}
